import { render } from "./Service.vue?vue&type=template&id=02c63de0&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=02c63de0&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/pro-base3-fe-portal-old1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c63de0"]])

export default __exports__